export default "__VITE_ASSET__97da71e0__"